import { useState, useRef, useCallback, useEffect } from 'react';
import { useNotificationSound } from './useNotificationSound';

/**
 * Custom hook for managing notifications with sound and 5-second display
 * Can be used in both admin and user components
 */
export const useNotification = () => {
  const [notification, setNotification] = useState(null);
  const timeoutRef = useRef(null);
  const { playNotificationSound } = useNotificationSound();

  const showNotification = useCallback((message) => {
    playNotificationSound();
    setNotification(message);
    
    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    
    // Hide notification after 5 seconds
    timeoutRef.current = setTimeout(() => {
      setNotification(null);
    }, 5000);
  }, [playNotificationSound]);

  // Call this in component cleanup
  const cleanup = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setNotification(null);
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return {
    notification,
    showNotification,
    cleanup
  };
};
